import React from "react";
import "./popups.scss";

import QRCode from "easyqrcodejs";

import PalamoaMobileLogo from "../../../../assets/android-chrome-192x192.png";
import PalamoaQRLogo from "../../../../assets/pmbw.png";
// TODO: show! import PlayStoreBadge from "../../../../assets/google-play-badge.png";

import { getqrtoken } from "../../../../api/login";
import { withTranslation } from 'react-i18next';
const globalQROptions = {
  width: 150,
  height: 150,
  logo: PalamoaMobileLogo
};

class MobileQRWindow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { ready: false };
    this.qrcode = undefined;
  }

  componentDidMount() {
    window.setTimeout(() => {
      this.setState({ ready: true });
    }, 100);
    this.onRequestQR.bind(this)();
  }

  async onRequestQR() {
    // promise to get qr.then...
    let { user = {} } = this.props;
    let { id: userid = 'nouserid' } = user;
    let token = "palamoa_fallback_token";

    try {
      let res = await getqrtoken(userid)
      token = res.data.token
    } catch (error) {
      console.log(error)      
    }
    console.log('onRequestQR', userid, token)



    let options = { ...globalQROptions, text: token, logo: PalamoaQRLogo, logoBackgroundTransparent: true, logoWidth: 56, logoHeight: 56 };
    if (this.qrcode) this.qrcode.clear();
    this.qrcode = new QRCode(this.el, options);
  }

  render() {
    let {t} = this.props;
    let popupCssClass = "popup";
    popupCssClass += this.state.ready ? " ready" : "";
    return (
      <div className={popupCssClass}>
        <div className="popup-inner" style={{ maxWidth: 600 }}>
          <div style={{ textAlign: "center", marginBottom: "1.2em" }}>
            {" "}
            <img width="80" src={PalamoaMobileLogo} alt=""/>
          </div>
          <h1>{t('qr_heading')}</h1>
          <br />
          <p>
          {t('qr_text1')}
          </p>
          <br />
{/*           <div style={{ textAlign: "center", marginBottom: "1.2em" }}>
            {" "}
            <img height="80" src={PlayStoreBadge} />
          </div>
 */}
          <h2>{t('qr_heading_login')}</h2>
          <br />
          <p>
          {t('qr_text2')}
          </p>
          <br /> <br />
          <div ref={el => (this.el = el)} />
          <br />
          <a style={{ cursor: 'pointer' }} onClick={this.onRequestQR.bind(this)} href>{t('reload_word')}</a>
        </div>
        <div className="popup-controls">
          <div className="modal-button" onClick={this.props.onHide}>
          {t('close_word')}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(MobileQRWindow);
